import { useAuthUser } from 'auth/hooks';
import { ModeToggle } from 'core/elements/ModeToggle';
import { SwitchUserVersionProvider } from 'core/states';
import { NotificationBell } from 'notifications';

import { GlobalSearch } from './GlobalSearch';
import { RightSideWrapper, Wrapper } from './headerStyle';
import ProfileMenu from './ProfileMenu';
import SwitchVersion from './SwitchVersion';

const Header = ({
  hasSwitchVersion,
  hasGlobalSearch = true,
}: {
  hasSwitchVersion?: boolean;
  hasGlobalSearch?: boolean;
}) => {
  const { user } = useAuthUser();

  return (
    <Wrapper hasGlobalSearch={hasGlobalSearch}>
      {hasGlobalSearch && <GlobalSearch />}

      <RightSideWrapper component="section">
        {hasSwitchVersion && (
          <SwitchVersion
            defaultVersionViewType={user?.settings?.defaultVersionViewType}
            userPermissions={user?.resources}
          />
        )}

        <ModeToggle />

        {user && (
          <>
            <NotificationBell />

            <SwitchUserVersionProvider>
              <ProfileMenu user={user} />
            </SwitchUserVersionProvider>
          </>
        )}
      </RightSideWrapper>
    </Wrapper>
  );
};

export default Header;
